export const DesktopFeature = {
	mask: {
		id: 'mask',
		availableFromVersion: 72
	}
};